import type { ReduxState } from '../types/internal/ReduxState';

export default ({ sendTimeout }: ReduxState): number => sendTimeout;
